import React from 'react';
import { useSelector } from 'react-redux';
import { Switch } from '@adobe/react-spectrum';
import { Flex } from '@react-spectrum/layout';
import Light from '@spectrum-icons/workflow/Light';
import Moon from '@spectrum-icons/workflow/Moon';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { analytics } from 'app/utils/analytics';
import { getColorScheme } from 'app/utils/varia';
export const SchemeSwitch = () => {
    const dispatch = useAppDispatch();
    const mode = useSelector((state) => state.editor.scheme);
    const curentScheme = mode !== null && mode !== void 0 ? mode : getColorScheme();
    const onModeSwitch = React.useCallback(() => {
        const nextMode = curentScheme === 'light' ? 'dark' : 'light';
        analytics({ action: 'ThemeSwitch', label: nextMode });
        dispatch(EditorActions.setScheme({ scheme: nextMode }));
    }, [curentScheme, dispatch]);
    return (React.createElement(Flex, { alignItems: "center" },
        React.createElement(Light, { size: "XS" }),
        React.createElement(Switch, { "data-test-id": "scheme-switch", isSelected: curentScheme === 'dark', onChange: onModeSwitch, height: "100%", marginX: "size-100", "aria-label": "Color theme switch" }),
        React.createElement(Moon, { size: "XS" })));
};
